import React, {FunctionComponent} from 'react';

import {getCSSVariableValue} from '../../../libs/get-css-variable-value';

interface Props {
  isBeforeYear1945: boolean;
  isSelected?: boolean;
}

const MapMarker: FunctionComponent<Props> = (props: Props) => {
  const {isBeforeYear1945, isSelected} = props;

  // Get color variables
  const blue = getCSSVariableValue('dhm-map-blue');
  const lightBlue = getCSSVariableValue('dhm-map-light-blue');
  const darkBlue = getCSSVariableValue('dhm-map-dark-blue');
  const yellow = getCSSVariableValue('dhm-map-yellow');
  const lightYellow = getCSSVariableValue('dhm-map-light-yellow');
  const darkYellow = getCSSVariableValue('dhm-map-dark-yellow');
  const white = getCSSVariableValue('dhm-map-white');

  // Define svg color variables
  // Colors when marker is selected
  const isSelectedFillColor = isBeforeYear1945 ? yellow : blue;
  const isSelectedStrokeAndCircletColor = isBeforeYear1945
    ? darkYellow
    : darkBlue;

  // Fill color
  const defaultFillColor = isBeforeYear1945 ? darkYellow : blue;
  const fillColor = isSelected ? isSelectedFillColor : defaultFillColor;

  // Stroke color
  const strokeColor = isSelected ? isSelectedStrokeAndCircletColor : white;

  // Circle color
  const defaultColorCircle = isBeforeYear1945 ? lightYellow : lightBlue;
  const circleColor = isSelected
    ? isSelectedStrokeAndCircletColor
    : defaultColorCircle;

  return (
    <svg viewBox="0 0 36.2 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M 31.458397,17.963313 C 31.458397,27.471435 18.1,37.800829 18.1,37.800829 c 0,0 -13.358397,-10.329394 -13.358397,-19.837516 0,-7.303951 5.980777,-13.225009 13.358397,-13.225009 7.377619,0 13.358397,5.921058 13.358397,13.225009 z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="3"
        filter="url(#marker-svg-filter)"
      />
      <circle cx="18.1" cy="18.1" r="5" fill={circleColor} />
      <defs>
        <filter
          id="marker-svg-filter"
          x="0"
          y="0"
          width="36.2"
          height="43"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.933333 0 0 0 0 0.866667 0 0 0 0 0.580392 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default MapMarker;
